/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ChangeStatusCommand } from '../models/change-status-command';
import { ListingReviewInviteCommand } from '../models/listing-review-invite-command';
import { ListingSearchQuery } from '../models/listing-search-query';
import { ListingSearchResultView } from '../models/listing-search-result-view';
import { ListingView } from '../models/listing-view';
import { UpdateListingCommand } from '../models/update-listing-command';

@Injectable({
  providedIn: 'root',
})
export class ListingService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation create
   */
  static readonly CreatePath = '/api/Listing/Create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  create$Response(params?: {
    context?: HttpContext
    body?: UpdateListingCommand
  }
): Observable<StrictHttpResponse<ListingView>> {

    const rb = new RequestBuilder(this.rootUrl, ListingService.CreatePath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ListingView>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  create(params?: {
    context?: HttpContext
    body?: UpdateListingCommand
  }
): Observable<ListingView> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<ListingView>) => r.body as ListingView)
    );
  }

  /**
   * Path part for operation getNew
   */
  static readonly GetNewPath = '/api/Listing/GetNew';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNew()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNew$Response(params?: {
    context?: HttpContext
  }
): Observable<StrictHttpResponse<ListingView>> {

    const rb = new RequestBuilder(this.rootUrl, ListingService.GetNewPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ListingView>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getNew$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNew(params?: {
    context?: HttpContext
  }
): Observable<ListingView> {

    return this.getNew$Response(params).pipe(
      map((r: StrictHttpResponse<ListingView>) => r.body as ListingView)
    );
  }

  /**
   * Path part for operation update
   */
  static readonly UpdatePath = '/api/Listing/Update';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `update()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  update$Response(params?: {
    context?: HttpContext
    body?: UpdateListingCommand
  }
): Observable<StrictHttpResponse<ListingView>> {

    const rb = new RequestBuilder(this.rootUrl, ListingService.UpdatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ListingView>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `update$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  update(params?: {
    context?: HttpContext
    body?: UpdateListingCommand
  }
): Observable<ListingView> {

    return this.update$Response(params).pipe(
      map((r: StrictHttpResponse<ListingView>) => r.body as ListingView)
    );
  }

  /**
   * Path part for operation getListing
   */
  static readonly GetListingPath = '/api/Listing/GetListing/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getListing()` instead.
   *
   * This method doesn't expect any request body.
   */
  getListing$Response(params: {
    id: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<ListingView>> {

    const rb = new RequestBuilder(this.rootUrl, ListingService.GetListingPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ListingView>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getListing$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getListing(params: {
    id: string;
    context?: HttpContext
  }
): Observable<ListingView> {

    return this.getListing$Response(params).pipe(
      map((r: StrictHttpResponse<ListingView>) => r.body as ListingView)
    );
  }

  /**
   * Path part for operation search
   */
  static readonly SearchPath = '/api/Listing/Search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `search()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  search$Response(params?: {
    context?: HttpContext
    body?: ListingSearchQuery
  }
): Observable<StrictHttpResponse<ListingSearchResultView>> {

    const rb = new RequestBuilder(this.rootUrl, ListingService.SearchPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ListingSearchResultView>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `search$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  search(params?: {
    context?: HttpContext
    body?: ListingSearchQuery
  }
): Observable<ListingSearchResultView> {

    return this.search$Response(params).pipe(
      map((r: StrictHttpResponse<ListingSearchResultView>) => r.body as ListingSearchResultView)
    );
  }

  /**
   * Path part for operation canEdit
   */
  static readonly CanEditPath = '/api/Listing/CanEdit/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `canEdit()` instead.
   *
   * This method doesn't expect any request body.
   */
  canEdit$Response(params: {
    id: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, ListingService.CanEditPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `canEdit$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  canEdit(params: {
    id: string;
    context?: HttpContext
  }
): Observable<boolean> {

    return this.canEdit$Response(params).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

  /**
   * Path part for operation canEditOrIsActive
   */
  static readonly CanEditOrIsActivePath = '/api/Listing/CanEditOrIsActive/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `canEditOrIsActive()` instead.
   *
   * This method doesn't expect any request body.
   */
  canEditOrIsActive$Response(params: {
    id: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, ListingService.CanEditOrIsActivePath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `canEditOrIsActive$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  canEditOrIsActive(params: {
    id: string;
    context?: HttpContext
  }
): Observable<boolean> {

    return this.canEditOrIsActive$Response(params).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

  /**
   * Path part for operation listingIsActive
   */
  static readonly ListingIsActivePath = '/api/Listing/ListingIsActive/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listingIsActive()` instead.
   *
   * This method doesn't expect any request body.
   */
  listingIsActive$Response(params: {
    id: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, ListingService.ListingIsActivePath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `listingIsActive$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listingIsActive(params: {
    id: string;
    context?: HttpContext
  }
): Observable<boolean> {

    return this.listingIsActive$Response(params).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

  /**
   * Path part for operation changeStatus
   */
  static readonly ChangeStatusPath = '/api/Listing/ChangeStatus';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `changeStatus()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  changeStatus$Response(params?: {
    context?: HttpContext
    body?: ChangeStatusCommand
  }
): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, ListingService.ChangeStatusPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `changeStatus$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  changeStatus(params?: {
    context?: HttpContext
    body?: ChangeStatusCommand
  }
): Observable<boolean> {

    return this.changeStatus$Response(params).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

  /**
   * Path part for operation reviewInvite
   */
  static readonly ReviewInvitePath = '/api/Listing/ReviewInvite';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reviewInvite()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  reviewInvite$Response(params?: {
    context?: HttpContext
    body?: ListingReviewInviteCommand
  }
): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ListingService.ReviewInvitePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reviewInvite$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  reviewInvite(params?: {
    context?: HttpContext
    body?: ListingReviewInviteCommand
  }
): Observable<void> {

    return this.reviewInvite$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation addToRecent
   */
  static readonly AddToRecentPath = '/api/Listing/AddToRecent';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addToRecent()` instead.
   *
   * This method doesn't expect any request body.
   */
  addToRecent$Response(params?: {
    id?: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ListingService.AddToRecentPath, 'put');
    if (params) {
      rb.query('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `addToRecent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  addToRecent(params?: {
    id?: string;
    context?: HttpContext
  }
): Observable<void> {

    return this.addToRecent$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
